<template>
  <div class="flex flex-col justify-center items-center">
    <div class="flex justify-center">
      <img src="@/assets/logo.png" alt="logo" class="logoIllyBig">
    </div>
    <button @click="handleSubmit" class="start-btn">
      <span>QUIZ</span>
      <svg
    id="Group_8"
    data-name="Group 8"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    class="responsive-svg"
    viewBox="0 0 10.016 17.369"
  >
    <defs>
      <clipPath id="clip-path">
        <rect id="Rectangle_20" data-name="Rectangle 20" width="10.016" height="17.369" fill="#fff"/>
      </clipPath>
    </defs>
    <g id="Group_7" data-name="Group 7" clip-path="url(#clip-path)">
      <path
        id="Path_5"
        data-name="Path 5"
        d="M10.016,8.671,1.615.27l0,0h0A.949.949,0,0,0,.269,1.608h0L7.344,8.683.271,15.757h0A.949.949,0,0,0,1.611,17.1h0l8.4-8.4L10,8.683Z"
        transform="translate(0 0)"
        fill="#fff"
      />
    </g>
  </svg>
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    handleSubmit() {
      this.$emit("next-step");
    },
  },
};
</script>

<style scoped>
.logoIllyBig {
  width: 60%;
  box-shadow: inset 0px 0 20px 20px rgb(43 43 43 / 11%), 0px 3px 20px 0 rgb(43 43 43 / 11%);
}

.start-btn {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 15px;
  padding-top: 20px;
  font-size: 16px;
  font-weight: 700;
  color: white;
}

.responsive-svg {
  width: 10px;
  height: 17px;
}

@media (min-width: 900px) {
  .logoIllyBig {
    width: 55vw;
  }

  .start-btn {
    width: 88vw;
    gap: 30px;
    padding-top: 30px;
    font-size: 40px;
  }

  .responsive-svg {
    width: 18px;
    height: 30px;
  }
}
</style>
